/**
 * Save button and error display at the bottom of the profile edit form.
 * Hidden entirely when the profile is read-only.
 */
import { ActivityIndicator } from "react-native";

import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";

import { Section } from "@/components/ui/section";
import { TEST_IDS } from "@/testIdDefinition";
import { useTranslation } from "react-i18next";

type ProfileFormActionsProps = {
    readOnly: boolean;
    isSaving: boolean;
    saveError: string | null;
    onSave: () => void | Promise<void>;
};

export function ProfileFormActions({
    readOnly,
    isSaving,
    saveError,
    onSave,
}: ProfileFormActionsProps) {
    const { t } = useTranslation();
    return (
        <>
            {saveError ? (
                <Section>
                    <Text className="text-destructive">{saveError}</Text>
                </Section>
            ) : null}

            {!readOnly ? (
                <Button
                    onPress={onSave}
                    disabled={isSaving}
                    testID={TEST_IDS[TEST_IDS.PROFILE_SAVE_BUTTON]}
                >
                    {isSaving ? (
                        <ActivityIndicator />
                    ) : (
                        <Text>{t("profile.saveChanges")}</Text>
                    )}
                </Button>
            ) : null}
        </>
    );
}
